import React from 'react';
import type { ReactElement, ReactNode } from 'react';

import classnames from 'classnames';

import { type SizeType } from '../../../../features/config';
import { Button, type ButtonProps, type ButtonType } from '../../../Button';

import styles from './BreadcrumbItemButton.module.scss';

type BreadcrumbItemButtonProps = {
    children: ReactNode;
    className?: string;
    size?: SizeType;
    type?: ButtonType;
    href?: string;
    onClick?: ButtonProps['onClick'];
};

export const BreadcrumbItemButton = ({
    children,
    className,
    size,
    ...rest
}: BreadcrumbItemButtonProps): ReactElement => {
    return (
        <Button
            className={classnames(styles.container, className)}
            type="ghost"
            color="neutral"
            size={size}
            {...rest}
        >
            {children}
        </Button>
    );
};
